import React from "react";
import { VotePaperInfo, VoteTypeMap } from "API/vote";
import style from "./index.module.scss";
import VoteQuestion from "./components/VoteQuestion";

interface VoteFormProps {
    data: VotePaperInfo | null;
    onSuccess: () => void;
}

export default function VoteForm({ data, onSuccess }: VoteFormProps) {
    if (!data) return null;

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                【{VoteTypeMap[data.type]}】 请根据老师口述的题目或观点进行投票
            </h1>

            <VoteQuestion data={data} onSuccess={onSuccess} />
        </div>
    );
}
